import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'Papier oder digital?',
  a: '100% digital — PDF in hoher Auflösung, sofort auf iPad, Tablet oder Smartphone zugänglich.'
}, {
  q: 'Wann erhalte ich meinen Zugang?',
  a: 'Sofort nach dem Kauf — innerhalb von 2 Minuten per E-Mail.'
}, {
  q: 'Zutaten in deutschen Supermärkten erhältlich?',
  a: 'Ja. Alles bei Rewe, Edeka, Lidl oder Aldi — erschwinglich und leicht verfügbar.'
}, {
  q: 'Brauche ich Vorkenntnisse in der Küche?',
  a: 'Nein. Das System funktioniert für absolute Anfänger genauso wie für Fortgeschrittene.'
}, {
  q: 'Ist das System für Diabetiker geeignet?',
  a: 'Ja, absolut. Alle Rezepte sind zuckerfrei und darauf ausgelegt, den Blutzucker stabil zu halten.'
}, {
  q: 'Ich habe Zöliakie. Sind die Rezepte sicher?',
  a: 'Ja, alle 500 Rezepte sind zu 100% glutenfrei.'
}, {
  q: 'Muss ich Kalorien zählen?',
  a: 'Nein. Das System konzentriert sich auf die richtigen Zutaten, nicht auf restriktives Zählen.'
}, {
  q: 'Sind die Rezepte familientauglich?',
  a: 'Ja, die Gerichte sind so lecker, dass die ganze Familie sie lieben wird, ohne zu merken, dass sie "gesund" sind.'
}, {
  q: 'Wie funktioniert die 30-Tage-Garantie?',
  a: 'Wenn Sie nicht zufrieden sind, schreiben Sie uns einfach eine E-Mail und wir erstatten Ihnen den vollen Betrag.'
}, {
  q: 'Ist die Zahlung sicher?',
  a: 'Ja, wir nutzen modernste SSL-Verschlüsselung, um Ihre Daten zu 100% zu schützen.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-8 sm:py-12 px-4 bg-brand-cream" data-id="element-53">
      <div className="max-w-xl mx-auto" data-id="element-54">
        <h2 className="text-2xl sm:text-3xl font-serif font-bold text-center mb-6 sm:mb-8 text-brand-text-main" data-id="element-55">
          Häufig gestellte Fragen
        </h2>

        <div className="space-y-3" data-id="element-56">
          {faqs.map((faq, i) => <div key={i} className="bg-white border border-brand-sage/30 rounded-xl overflow-hidden shadow-sm" data-id="element-57">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-5 py-4 text-left flex justify-between items-center hover:bg-brand-sage-light transition-colors gap-4" data-id="element-58">
                <span className="font-bold text-brand-text-main text-xs sm:text-sm" data-id="element-59">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-brand-olive transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-60" />
              </button>

              {openIndex === i && <div className="px-5 pb-4 pt-0 text-xs sm:text-sm text-brand-text-muted font-medium leading-relaxed" data-id="element-61">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}